import { css, cx } from "@emotion/css"

const SectionHeading = ({
  children,
  sub,
  subColor,
  labelId,
  className,
}: {
  children: React.ReactNode
  sub?: string
  subColor?: string
  labelId?: string
  className?: string
}) => {
  return (
    <h2 id={labelId} className={cx(styles.heading, className)}>
      {children}
      {sub && (
        <span className={styles.sub} style={{ color: subColor }}>
          {sub}
        </span>
      )}
    </h2>
  )
}

export default SectionHeading

const styles = {
  heading: css`
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    color: #32383e;
  `,
  sub: css`
    font-size: 13px;
    font-weight: normal;
  `,
}
